// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-grid {
  margin: 15px 20px;
}

p {
  margin: 0;
}

h5 {
  margin: 1em 0 0.1em;
}

h6 {
  margin: 0.4em 0 0.1em;
}

.margin-top-small {
  margin: 0.5em 0 0.1em;
}

.margin-top-large {
  margin: 1em 0 0.3em;
}

.bottom {
  padding-bottom: 2em !important;
}

.row-vertical-center {
  align-items: center;
}

.col-full {
  height: 100%;
}

ion-grid.tabular-data {
  margin: 0 5px;
}

.tabular-data ion-row ion-col {
  font-size: 1.3rem;
}

.row-hover {
  cursor: pointer;
  background: #eee;
  text-align: center;
}

.landscape-only {
  display: none;
}

@media screen and (orientation: landscape) {
  .landscape-only {
    display: block;
  }
  .tabular-data ion-row ion-col {
    font-size: 1.1rem;
  }
}
@media (orientation: landscape) {
  ion-content {
    --padding-start: calc(var(--sar, 0px) / 1.5);
    --padding-end: calc(var(--sal, 0px) / 1.5);
  }
}

.hyperlink {
  color: #0063CF;
  text-decoration: none;
  cursor: pointer;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/rewards/bonuses/active-bonuses/active-bonuses.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;;AAEA;EACI,SAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,qBAAA;AACJ;;AAEA;EACI,qBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,8BAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI;IACI,cAAA;EACN;EAEE;IACI,iBAAA;EAAN;AACF;AAGI;EADJ;IAEM,4CAAA;IACA,0CAAA;EAAJ;AACF;;AAGE;EACE,cAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AAAJ","sourcesContent":["ion-grid {\r\n    margin: 15px 20px;\r\n}\r\n\r\np {\r\n    margin: 0;\r\n}\r\n\r\nh5 {\r\n    margin: 1em 0 0.1em;\r\n}\r\n\r\nh6 {\r\n    margin: 0.4em 0 0.1em;\r\n}\r\n\r\n.margin-top-small {\r\n    margin: 0.5em 0 0.1em;\r\n}\r\n\r\n.margin-top-large {\r\n    margin: 1em 0 0.3em;\r\n}\r\n\r\n.bottom {\r\n    padding-bottom: 2em !important;\r\n}\r\n\r\n.row-vertical-center {\r\n    align-items: center;\r\n}\r\n\r\n.col-full {\r\n    height: 100%;\r\n}\r\n\r\nion-grid.tabular-data {\r\n    margin: 0 5px;\r\n}\r\n\r\n.tabular-data ion-row ion-col {\r\n    font-size: 1.3rem;\r\n}\r\n\r\n.row-hover {\r\n    cursor: pointer;\r\n    background: #eee;\r\n    text-align: center;\r\n}\r\n\r\n.landscape-only {\r\n    display: none;\r\n}\r\n\r\n@media screen and (orientation: landscape) {\r\n    .landscape-only {\r\n        display: block;\r\n    }\r\n\r\n    .tabular-data ion-row ion-col {\r\n        font-size: 1.1rem;\r\n    }\r\n}\r\nion-content {\r\n    @media (orientation: landscape) {\r\n      --padding-start: calc(var(--sar, 0px) / 1.5);\r\n      --padding-end: calc(var(--sal, 0px) / 1.5);\r\n    }\r\n  }\r\n\r\n  .hyperlink{\r\n    color: #0063CF;\r\n    text-decoration: none;\r\n    cursor: pointer;\r\n    font-weight: 600;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
